<template>
  <div id="view-login-container" @keyup.enter="login">
    <div id="view-login" class="container is-fluid">
      <div id="logo-container" class="column">
        <img id="logo" src="../../assets/images/coches-big-black.png">
      </div>
      <div id="login-form-container">
        <p class="control has-icon">
          <input v-model="user.email"
                 class="input" 
                 type="email" 
                 placeholder="Email"
          ><i class="fa fa-envelope"></i>
        </p>
        <p class="control has-icon">
          <input v-model="user.password"
                 class="input" 
                 type="password" 
                 placeholder="Password"
          ><i class="fa fa-lock"></i>
        </p>
        <p id="login-btn-container" class="control">
          <button @click="login"
                  class="btn-submit-login button is-success"
                  v-bind:class="[btnIsLoading ? 'is-loading' : '']"
          >Login
          </button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      user: {
        email: '',
        password: ''
      }
    }
  },

  route: {
    activate: function (transition) {
      this.token ? transition.redirect('/') : transition.next()
    }
  },

  computed: {
    btnIsLoading () {
      if (this.$store.state.notification.loadingButtons.includes('.btn-submit-login')) {
        return true
      }
      return false
    }
  },

  methods: {
    login () {
      let user = this.user
      if (user.email && user.password) {
        this.$store.dispatch('localLogin', user)
      }
    }
  }
}
</script>

<style lang="scss">
  @import '~bulma/sass/utilities/variables';
  
  #view-login-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }

  #logo-container, #login-form-container {
    max-width: 500px;
  }

  #logo {
    margin: 0 auto;
  }

  #login-btn-container {
    display: flex;
    justify-content: flex-end;
  }
</style>


// WEBPACK FOOTER //
// index.vue?00a5b7da